.fp-vertical-spacing.-s-sm(data-test='language-selector')
  .fp-vertical-spacing--line
    span.fp-text.-text-sm.-text-semi-bold {{ t('language') }}
  .fp-vertical-spacing--line
    .fp-horizontal-spacing.-s-sm
      .fp-horizontal-spacing--column(v-for='clubLanguage in clubLanguages' @click='setLanguage(clubLanguage)' :data-test='clubLanguage')
        a.fp-link
          img.fp-illustration.-xs(:class='`-flag-${clubLanguage}`')
